import * as Api from '@/api/api.js';
import {useRequest} from "ahooks";

export type Nav = {
    selfRun: string
    shopStreet: string
    news: string
    secKill: string
    merchant: string
    introduce: string
    video: string
    myBrowseHistory: string
    myCollect: string
    customerService: string
    meta: string
}

export type Params = {
    onSuccess?: (nav: Nav) => void
}

export default function useFetchNav(params: Params = {}) {
    const {
        onSuccess = (nav) => {
        }
    } = params

    const {data, loading, run} = useRequest(
        () => Api.nav(),
        {
            onSuccess: (nav: Nav) => {
                onSuccess(nav)
            }
        }
    )

    return {
        data, loading, run
    }
}